import { S2SafeParsable } from 'libs/end-to-end/src/interfaces';
import { zodParseSafe } from 'libs/end-to-end/src/utils/utility/zod-parse-safe';
import { errResult } from 'libs/end-to-end/src/result';
import { Result } from 'libs/end-to-end/src/result';
import { jsonParseUnknown } from 'libs/end-to-end/src/utils/utility/json-parse-unknown';
import { JsonParseFatalError } from 'libs/end-to-end/src/types/errors/json-parse-fatal-error';
import { ZodParseError } from 'libs/end-to-end/src/types/errors/zod-parse-error';

export const jsonParse = <TRecord>(
  json: string,
  schema: S2SafeParsable<unknown, TRecord>,
): Result<TRecord, JsonParseFatalError | ZodParseError> => {
  const parseUnknownResult = jsonParseUnknown(json);

  if (parseUnknownResult.resultType === 'err') {
    return errResult(parseUnknownResult.error);
  }

  return zodParseSafe(parseUnknownResult.value, schema);
};
